import { Bound } from "lib/@components/binding/Bound"
import { FacilityOverrides } from "routes/facilities/facility-overrides"
import Schedules from "routes/schedule/schedules"
import { ExtendedSchedule } from "routes/schedule/extendedSchedule"
import Schedule from "routes/schedule/schedule"
import { useSearchParam } from "lib/@hooks/use-search-param"

export function FacilityScheduleImpl() {
    const [share] = useSearchParam("share", null)

    return (
        <Bound inSelector={true} isShare={!!share}>
            <FacilityOverrides>
                <Schedules>
                    <ExtendedSchedule>
                        <Schedule $lazy />
                    </ExtendedSchedule>
                </Schedules>
            </FacilityOverrides>
        </Bound>
    )
}
